import { Chip } from "../molecules"
import { Avatar, Button, Text } from "../atoms"
import { CompanyV2 } from "@/types/company" // Recomendo criar esse type ou atualizar o existente
import giantsSymbol from "@/assets/giants-symbol-white.png"
import { useAuth } from "@/contexts/AuthContext"

interface CompaniesListProps {
  company: any // Substitua pelo seu novo Type da V2
  onActionClick?: () => void
  onCardClick?: () => void
}

export const CompaniesList = ({ company, onCardClick, onActionClick }: CompaniesListProps) => {
  const { user } = useAuth()

  const handleActionClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.stopPropagation()
    if (onActionClick) {
      onActionClick()
    }
  }

  // Verificações baseadas no novo modelo camelCase
  const isMainMentor = company.mentorId === user?.mentor_id
  const isGiants = company.tipoPrograma === 1
  const isPac = company.tipoPrograma === 2
  const isInactive = company.statusEmpresa === 0

  return (
    <div
      onClick={onCardClick}
      className="relative mt-[60px] flex min-h-[180px] cursor-pointer flex-col items-center justify-between gap-2 rounded-[8px] border border-transparent bg-dark-500 p-[20px] transition-all hover:z-10 hover:scale-105 hover:border-primary"
    >
      <div className="mt-[-60px] flex flex-col items-center justify-center gap-4">
        <div className="relative">
          <Avatar
            src={company.empLogoUrl} // V2: empLogoUrl
            alt={company.nomeFantasia} // V2: nomeFantasia
            size="lg"
          />
        </div>
      </div>

      <Text
        className="text-center"
        variant="h6"
      >
        {company.nomeFantasia}
      </Text>

      <div className="flex flex-wrap justify-center gap-1">
        {user.mentorId === company.mentorId && !user.admin && (
          <Chip
            variant="primary"
            title="Você é mentor principal dessa empresa"
          >
            <i className="fi fi-ss-star flex items-center justify-center text-[.9rem]" />
            Principal
          </Chip>
        )}

        {isGiants && (
          <Chip>
            <img
              src={giantsSymbol}
              alt="Giants"
              className="mr-2 h-[15px]"
            />
            {company.tipoProgramaDesc}
          </Chip>
        )}

        {isPac && <Chip variant="info">PAC</Chip>}
      </div>

      <div className="w-full border-t border-t-dark-400 pt-2 text-center">
        <Button
          disabled={isInactive}
          onClick={handleActionClick}
          icon="calendar"
          variant="ghost"
          size="xs"
        >
          Agendar Mentoria
        </Button>
      </div>
    </div>
  )
}
